/**
 * Copie locală a `createMiddleware` din @tanstack/start-client-core.
 *
 * `src/start.ts` este intrarea "start entry" a aplicației. Dacă importă
 * `createMiddleware` din @tanstack/react-start, bundler-ul de producție împarte
 * serverul în două chunk-uri cu import circular, iar SSR cade cu
 * `TypeError: createCsrfMiddleware is not a function`. Importul direct din
 * @tanstack/start-client-core rezolvă ciclul, dar aduce `node:async_hooks` în
 * bundle-ul de browser și rupe hidratarea.
 *
 * Implementarea de mai jos este pur declarativă (doar construiește un obiect de
 * opțiuni), deci o putem păstra local fără să atingem niciunul dintre pachete.
 * Tipul este preluat din pachetul oficial printr-un import de tip, care se
 * șterge complet la compilare.
 */
import type { createMiddleware as createMiddlewareType } from "@tanstack/react-start";

type AnyOptions = Record<string, unknown>;

const createMiddlewareImpl = (options?: AnyOptions, __opts?: AnyOptions): unknown => {
  const resolvedOptions: AnyOptions = { type: "request", ...(__opts || options) };

  const setValidator = (validator: unknown) =>
    createMiddlewareImpl({}, Object.assign(resolvedOptions, { validator, inputValidator: validator }));

  return {
    options: resolvedOptions,
    middleware: (middleware: unknown) =>
      createMiddlewareImpl({}, Object.assign(resolvedOptions, { middleware })),
    validator: setValidator,
    inputValidator: setValidator,
    client: (client: unknown) => createMiddlewareImpl({}, Object.assign(resolvedOptions, { client })),
    server: (server: unknown) => createMiddlewareImpl({}, Object.assign(resolvedOptions, { server })),
  };
};

export const createMiddleware = createMiddlewareImpl as unknown as typeof createMiddlewareType;
